import { Link, useNavigate } from 'react-router-dom';
import validator from 'validator';
import { PROFILE_EDIT_LINK, PROFILE_MAIN_LINK } from '../../../../assets/utils/constants';
import './EmailChange.css';
import ProfileGoBackButton from '../../ProfileGoBackButton/ProfileGoBackButton';

import { useContext, useState } from 'react';
import Input from '../../../Input/Input';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';
import { UserContext } from '../../../../assets/contexts/userContext';
import mainAppApi from '../../../../assets/api/MainAppApi';
import useAutoDismissError from '../../../../assets/hooks/useAutoDismissError';
import { parseApiError } from '../../../../assets/utils/utils';

function EmailChange() {
    const { user, setUser } = useContext(UserContext)

    const [values, setValues] = useState({
        email: '',
        code: '',
    })
    const [valuesValidity, setValuesValidity] = useState({
        email: {},
    })
    function handleChange(e) {
        const input = e.target;
        const name = input.name;
        let value = input.value;

        switch (name) {

            case 'code': {
                let inputValue = value.replace(/\D/g, '');
                setValues((prevValue) => ({
                    ...prevValue,
                    [name]: inputValue,
                }));

                break;
            }
            case 'email':
                if (!value) {
                    setValuesValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: '',
                            validState: false,
                        },
                    }));
                }
                if (value.length >= 2) {
                    if (validator.isEmail(value)) {
                        setValuesValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: true,
                            },
                        }));
                    } else {
                        setValuesValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: !e.target.validity.valid
                                    ? e.target.validationMessage
                                    : 'Invalid email',
                                validState: false,
                            },
                        }));
                    }
                }
                setValues((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;

            default:
                setValues((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;
        }
    }

    const [preloaders, setPreloaders] = useState({
        emailRequest: false,
        checkCode: false,
    })

    const [step, setStep] = useState(0)
    const [emailError, setEmailError] = useAutoDismissError()

    function handleEmailRequest() {
        setPreloaders(prevValue => ({
            ...prevValue,
            emailRequest: true,
        }))
        mainAppApi.changeEmail({
            email: values.email,
        })
            .then((res) => {
                console.log(res)
                setStep(1)

            })
            .catch((err) => {
                console.log(err)
                setEmailError(parseApiError(err))
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    emailRequest: false,
                }))
            })
    }

    const [codeError, setCodeError] = useAutoDismissError()
    function handleCheckCode() {
        setPreloaders(prevValue => ({
            ...prevValue,
            checkCode: true,
        }))
        mainAppApi.changeEmailCheckCode({
            code: values.code,
        })
            .then((res) => {
                console.log(res)
                setStep(2)
                setUser(prevValue => ({
                    ...prevValue,
                    email: values.email,
                }))
            })
            .catch((err) => {
                console.log(err)
                setCodeError('Oops! That code doesn’t seem right. Please try again.')
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    checkCode: false,
                }))
            })
    }
    const navigate = useNavigate()
    return (
        <div className='email-change'>
            <div className='email-change__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}/${PROFILE_EDIT_LINK}`)
                    }}
                />
                <div className='email-change__heading-title-box' >
                    <p className='email-change__heading-title'>Update Email</p>
                </div>
            </div>
            {step === 0 ?
                <>
                    <div className='email-change__inputs'>
                        <div className='email-change__input-item'>
                            <p className='email-change__input-title'>New email</p>
                            <div className='email-change__input-box'>
                                <Input
                                    value={values.email}
                                    handleChange={handleChange}
                                    name={"email"}
                                    placeholder={'Enter Your New Email'}
                                    inputMode='email'
                                />
                            </div>
                        </div>
                    </div>
                    <button className={`email-change__submit ${!(values.email && valuesValidity.email.validState && user.email !== values.email) || preloaders.emailRequest ? 'email-change__submit_inactive' : ''}`} type='button' onClick={handleEmailRequest}>
                        {preloaders.emailRequest ? <MiniPreloader isLinkColor={true} /> : 'Confirm New Email'}
                    </button>
                    {emailError ?
                        <p className='email-change__submit-error'>{emailError}</p>
                        : null}
                </>
                : null}

            {step === 1 ?
                <>
                    <div className='email-change__inputs'>
                        <div className='email-change__input-item'>
                            <p className='email-change__input-title'>Confirm Your New Email</p>
                            <p className='email-change__input-subtitle'>We&rsquo;ve sent a&nbsp;confirmation code to&nbsp;your new email. <br />Enter the code below to&nbsp;verify the change.</p>
                            <div className='email-change__input-box'>
                                <Input
                                    value={values.code}
                                    handleChange={handleChange}
                                    name={"code"}
                                    placeholder={'Enter code'}
                                    inputMode='numeric'
                                />
                            </div>
                        </div>
                    </div>
                    <button className={`email-change__submit ${!(values.code && values.code.length === 6) || preloaders.checkCode ? 'email-change__submit_inactive' : ''}`} type='button' onClick={handleCheckCode}>
                        {preloaders.checkCode ? <MiniPreloader isLinkColor={true} /> : 'Check code'}
                    </button>
                    {codeError ?
                        <p className='email-change__submit-error'>{codeError}</p>
                        : null}
                </>
                : null}

            {step === 2 ?
                <>
                    <div className='email-change__succsess'>
                        <p className='email-change__input-title'>Email Successfully Updated</p>
                        <p className='email-change__input-subtitle'>Your email has been changed. <br />From now&nbsp;on, you&rsquo;ll use your new address to&nbsp;sign in&nbsp;and receive updates.</p>

                    </div>
                    <Link to={`/${PROFILE_MAIN_LINK}`} className={`email-change__submit `} >
                        Return to profile
                    </Link>
                </>
                : null}



        </div>
    );
}

export default EmailChange